<template>
  <div class="tables-ctn">
    <!-- fields column -->
    <div class="fields-ctn">
      <table v-for="keyField in Object.keys(fields)" :key="keyField">
        <thead>
          <tr>
            <th class="text-left text-uppercase gradient-th">{{ keyField }}</th>
          </tr>
          <tr class="empty-row"></tr>
        </thead>
        <tbody>
          <tr
            v-for="(field, index) in fields[keyField]"
            :key="field.title"
            :class="{ 'mb-3 d-flex': field.spaceUnder }"
          >
            <td
              scope="row"
              class="text-left"
              :data-line-group="lineClass(keyField, index)"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 20 20"
                class="line-accordion-btn"
                :data-control="lineClass(keyField, index)"
                @click="toggleOpenLine(lineClass(keyField, index))"
              >
                <g fill="currentColor">
                  <path
                    d="m16.64 8.268l-6 5c-1.024.854-2.304-.683-1.28-1.536l6-5c1.024-.854 2.305.683 1.28 1.536Z"
                  />
                  <path
                    d="m4.64 6.732l6 5c1.024.853-.256 2.39-1.28 1.536l-6-5c-1.024-.853.256-2.39 1.28-1.536Z"
                  />
                </g>
              </svg>
              <span v-html="field.name"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- alloys infos -->
    <div class="alloy-cols-ctn">
      <!-- alloy column -->
      <div
        v-for="(alloy, index) in alloys"
        :key="index + '_' + alloy.isoDesignation"
        class="alloy-col"
      >
        <!-- group table -->
        <table
          v-for="keyField in Object.keys(fields)"
          :key="keyField + '-' + alloy.isoDesignation"
        >
          <thead>
            <tr>
              <th>&nbsp;</th>
            </tr>
            <tr class="empty-row"></tr>
          </thead>
          <tbody>
            <tr
              v-for="(field, index) in fields[keyField]"
              :key="alloy.isoDesignation + '-' + field.title"
              :class="{ 'mb-3 d-flex': field.spaceUnder }"
            >
              <td
                scope="row"
                :data-line-group="lineClass(keyField, index)"
                v-html="displayValue(field.title, alloy[field.title])"
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- empty cols -->
      <div
        v-for="k in 5 - alloys.length"
        :key="k + '_column'"
        class="alloy-col"
      >
        <!-- group table -->
        <table
          v-for="keyField in Object.keys(fields)"
          :key="k + '-' + keyField"
        >
          <thead>
            <tr>
              <th>&nbsp;</th>
            </tr>
            <tr class="empty-row"></tr>
          </thead>
          <tbody>
            <tr
              v-for="(field, index) in fields[keyField]"
              :key="k + '-' + field.title"
              :class="{ 'mb-3 d-flex': field.spaceUnder }"
            >
              <td
                scope="row"
                class="m-auto"
                :data-line-group="lineClass(keyField, index)"
              >
                —
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Fields from "@/config/fieldsDataSheet.js";
import $ from "jquery";

export default {
  name: "DataSheet",
  props: {
    alloys: {
      type: Array,
      default: null
    }
  },
  data: () => {
    return {
      fields: JSON.parse(JSON.stringify(Fields))
    };
  },
  watch: {
    alloys: function(oldAlloys, newAlloys) {
      this.$nextTick(() => {
        this.onSelectedAlloysChange();
      });

      return newAlloys;
    }
  },
  mounted() {
    this.displayAccordionBtn();
  },
  methods: {
    // Affiche le bouton accordéons pour les lignes, si du texte dépasse d'une cellule de cette ligne
    displayAccordionBtn() {
      const tdList = $("table td");
      for (let td of tdList) {
        if (td.offsetWidth < td.scrollWidth) {
          const line = $(td).data("line-group");
          $("[data-control='" + line + "']").show();
        }
      }
    },
    // Au clic sur le bouton d'accordéon
    toggleOpenLine(line) {
      $("[data-line-group='" + line + "']").toggleClass("open");
      $("[data-control='" + line + "']").toggleClass("active");
      this.setLineHeight(line);
    },
    // Permet de définir la hauteur maximum pour toutes les cellules d'une même ligne
    setLineHeight(line) {
      const cellsList = $("[data-line-group='" + line + "']");
      if (cellsList.hasClass("open")) {
        const maxHeight = Math.max.apply(
          null,
          cellsList
            .map(function() {
              return $(this).height();
            })
            .get()
        );
        cellsList.height(maxHeight);
      } else {
        cellsList.height("auto");
      }
    },
    /**
     * Lorsque les alliages changent :
     * - on active ou non l'affichage des boutons d'accordéons selon les données tronquées
     * - pour les boutons actif, on met à jour les cellules sur les autres colonnes (ajout d'une classe pour retirer l'ellipse, et hauteur)
     */
    onSelectedAlloysChange() {
      this.displayAccordionBtn();

      const activeAccordionBtnList = $(".line-accordion-btn.active");
      for (let accordionBtn of activeAccordionBtnList) {
        const line = $(accordionBtn).data("control");
        $("[data-line-group='" + line + "']").addClass("open");
        $("[data-line-group='" + line + "']").height("auto");

        this.setLineHeight(line);
      }
    },
    lineClass(keyField, index) {
      return "line-" + keyField.replaceAll(" ", "-") + "-" + index;
    },
    displayValue: function(title, value) {
      if (!value) return "—";
      if (title == "productUniverse") return value.split(" ", 3).join(" ");
      if (typeof value == "boolean") return value ? "&#11044;	" : "-";
      if (title == "NACECorrosion" || title == "friction") {
        let i;
        let stars = "";
        for (i = 0; i < 5; i++) {
          let div =
            i < value
              ? `<img src="${require("@/assets/icon-star.png")}" style="opacity:0.8;" alt>`
              : `<img src="${require("@/assets/icon-star.png")}" style="opacity:0.5;" alt>`;
          stars += div;
        }
        return stars;
      }
      return value;
    },
    isKeyNorms: function(title) {
      return title == "keyNorms" ? true : false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.tables-ctn {
  display: flex;
  table {
    margin-bottom: 32px;
    width: 100%;
    table-layout: fixed;
  }
  th,
  td {
    width: 100%;
    padding: 2px 0 2px 4px;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    &.open {
      text-overflow: inherit;
      white-space: inherit;
      overflow: inherit;
    }
  }
  th {
    background-color: rgb(211, 108, 72);
    width: 100%;
    height: 26px;
  }
  tr:nth-child(even) {
    background-color: rgb(242, 242, 237);
  }
  tr:nth-child(odd) {
    background-color: rgb(255, 255, 255);
  }
  .gradient-th {
    background-color: rgb(211, 108, 72);
    color: white;
  }
  .empty-row {
    height: 4px;
  }
  .alloy-col {
    width: calc((33.33vw - 20px) / 4);
    min-width: calc(460px / 4);
    margin: 0 4px;
  }
  .fields-ctn {
    width: 35%;
    min-width: 200px;
    margin-right: 4px;
  }
  .alloy-cols-ctn {
    display: flex;
    min-width: 640px;
  }
  .line-accordion-btn {
    display: none;
    cursor: pointer;
    margin-right: 5px;

    &.active {
      transform: rotate(180deg);
    }
  }
}
</style>
